
import "../framework/menu-helper.js"

import "./js/home.js"
import "./js/parallax-box-effect.js"
import "./js/news.js"
import "./js/logo.js"
import "./js/menu.js"
import "./js/tab.js"

import "../module/gallery/gallery.js"

import './lib/uikit-3.13.10/css/uikit.css';

import './scss/variables.scss';

import './scss/home.scss';
import './scss/mappa.scss';
import './scss/gravity-forms-table.scss';